<template>
  <div>
    <a
      :href="config && config.customerServiceLink"
      style="position: fixed; right: 20px; bottom: 60px; z-index: 999"
    >
      <van-icon name="service" size="30" color="#7832b0" />
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {}
    }
  },
  async created() {
    const res = await this.$request.getConfigDetail()
    if (res.retCode === '000') {
      this.config = res.result
    }
  },
  methods: {}
}
</script>
<style scoped lang="less"></style>
